export default "__VITE_ASSET__94a16913__"